import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {getResultInfo} from '@web/actions/result'
import {isRealProfile} from '@web/core/config'
import {getSha256} from '@web/helpers/crypto'
import {addNaverId, addVariant, getInitialState, ABTestState, setTrafficId} from '@web/slices/abTest/slice'

import {ABTestReducer, MakeSliceOptions} from './interfaces'

function getTrafficId(naverId: string) {
    return 'i:' + getSha256(isRealProfile ? 'real' : 'dev' + naverId)
}

export default (options?: MakeSliceOptions) =>
    createSlice<ABTestState, ABTestReducer, 'abTest', SliceSelectors<ABTestState>>({
        name: 'abTest',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(getResultInfo.fulfilled, (state, {payload}) => {
                    state.naverId = payload.purchaser.naverId
                    state.trafficId = payload.purchaser.naverId ? getTrafficId(payload.purchaser.naverId) : ''
                })
                .addCase(addVariant, (state, {payload}) => {
                    const {experimentId, variant} = payload
                    state.variantMap[experimentId] = variant
                })
                .addCase(addNaverId, (state, {payload}) => {
                    state.naverId = payload
                    if (!state.trafficId && payload) {
                        state.trafficId = getTrafficId(payload)
                    }
                })
                .addCase(setTrafficId, (state, {payload}) => {
                    state.trafficId = payload
                })
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.abTest ?? state
            })
        },
    })
